import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";
import { useEffect, useState } from "react";

const StepDetails = ({ details, setDetails, onBack, onNext }) => {
  const SPECIAL_REQUIREMENTS = [
    "Birthday",
    "Occasion – please describe in notes",
    "Wheelchair access required",
    "Dietary requirements (add details in notes)",
    "Corporate Function",
    "Low table preferred",
    "Terrace preferred if fine",
  ];

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const [errors, setErrors] = useState({});
  const validate = () => {
    const newErrors = {};

    if (!details.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    if (!details.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    if (!details.phone.trim()) {
      newErrors.phone = "Mobile is required";
    }

    if (!details.email.trim()) {
      newErrors.email = "Email is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const inputClass = (error) =>
    `
    w-full border-b bg-transparent py-2 text-sm
    focus:outline-none
    ${error ? "border-red-500 text-red-600" : "border-gray-400"}
  `;

  return (
    <div className="grid md:grid-cols-2 gap-4 pt-2">
      <motion.div
        variants={fadeUp}
        className="border rounded-lg p-6 space-y-4 text-text"
      >
        <div className="space-y-1">
          <label className="text-sm">
            First Name <span className="text-red-500">*</span>
          </label>

          <input
            value={details.firstName}
            onChange={(e) =>
              setDetails((d) => ({ ...d, firstName: e.target.value }))
            }
            className={inputClass(errors.firstName)}
          />

          {errors.firstName && (
            <p className="text-xs text-red-500">{errors.firstName}</p>
          )}
        </div>
        <div className="space-y-1">
          <label className="text-sm">
            Last Name <span className="text-red-500">*</span>
          </label>

          <input
            value={details.lastName}
            onChange={(e) =>
              setDetails((d) => ({ ...d, lastName: e.target.value }))
            }
            className={inputClass(errors.lastName)}
          />

          {errors.lastName && (
            <p className="text-xs text-red-500">{errors.lastName}</p>
          )}
        </div>
        <div className="space-y-1">
          <label className="text-sm">
            Mobile <span className="text-red-500">*</span>
          </label>

          <input
            placeholder="NZ +64"
            value={details.phone}
            onChange={(e) =>
              setDetails((d) => ({ ...d, phone: e.target.value }))
            }
            className={inputClass(errors.phone)}
          />

          {errors.phone && (
            <p className="text-xs text-red-500">{errors.phone}</p>
          )}
        </div>
        <div className="space-y-1">
          <label className="text-sm">
            Email <span className="text-red-500">*</span>
          </label>

          <input
            type="email"
            value={details.email}
            onChange={(e) =>
              setDetails((d) => ({ ...d, email: e.target.value }))
            }
            className={inputClass(errors.email)}
          />

          {errors.email && (
            <p className="text-xs text-red-500">{errors.email}</p>
          )}
        </div>
        <div className="space-y-1">
          <label className="text-sm text-gray-500">Company Name</label>

          <input
            value={details.company}
            onChange={(e) =>
              setDetails((d) => ({ ...d, company: e.target.value }))
            }
            className={inputClass(false)}
          />
        </div>
      </motion.div>

      <motion.div
        variants={fadeUp}
        className="border rounded-lg p-6 space-y-6 text-text"
      >
        {/* NOTES */}
        <div className="space-y-2">
          <label className="text-sm font-medium">Notes</label>
          <textarea
            value={details.notes}
            onChange={(e) =>
              setDetails((d) => ({ ...d, notes: e.target.value }))
            }
            placeholder="Please add any additional notes or requests here..."
            rows={4}
            className="
        w-full border-b border-gray-400 bg-transparent
        focus:outline-none focus:border-neonYellow
        text-sm resize-none
      "
          />
        </div>

        <hr className="border-gray-200" />

        {/* SPECIAL REQUIREMENTS */}
        <div className="space-y-3">
          <p className="font-medium">Special Requirements</p>

          {SPECIAL_REQUIREMENTS.map((item) => {
            const checked = details.specialRequests.includes(item);

            return (
              <label
                key={item}
                className="flex items-start gap-3 text-sm cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() =>
                    setDetails((d) => ({
                      ...d,
                      specialRequests: checked
                        ? d.specialRequests.filter((i) => i !== item)
                        : [...d.specialRequests, item],
                    }))
                  }
                  className="
              mt-0.5 w-4 h-4
              accent-neonYellow
              cursor-pointer
            "
                />
                <span>{item}</span>
              </label>
            );
          })}
        </div>
      </motion.div>

      <div className="flex justify-between lg:hidden gap-3">
        <button
          onClick={onBack}
          className="px-8 py-3 rounded-md border border-textGray text-sm hover:bg-border/40 transition text-textGray"
        >
          BACK
        </button>
        <button
          onClick={() => {
            if (validate()) {
              onNext();
            }
          }}
          className="px-8 py-3 bg-darkbg text-neonYellow hover:bg-neonYellow hover:text-navy rounded"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default StepDetails;
